import React from "react";

import { useUIStateStore } from "@/store/uiStateStore";

import { cn } from "../utils/utils";

type TextElements = "p" | "pMainFont" | "semibold" | "subtitle" | "small";

type TextProps<T extends HTMLElement = HTMLElement> = {
  children: React.ReactNode;
  as?: TextElements;
  className?: string;
} & React.HTMLAttributes<T>;

const Text = React.forwardRef<HTMLElement, TextProps>(({
  children,
  as = "p",
  className = "",
  ...props
}, ref) => {
  const isTunecore = useUIStateStore(state => state.isTunecore);

  const baseStyle = isTunecore ? "text-white font-tunecore" : "text-sentric-black-text";

  const styles = {
    p: cn(baseStyle, isTunecore ? "text-[0.875rem] font-normal" : "text-base font-normal leading-normal font-sentric-alt"),
    pMainFont: cn(baseStyle, "text-base font-normal leading-normal font-sentric"),
    semibold: cn(baseStyle, "font-semibold text-base leading-6 font-sentric-alt"),
    subtitle: cn(baseStyle, isTunecore ? "font-bold  text-white uppercase tracking-[0.06rem]" : "font-sentric text-base font-bold leading-7 uppercase"),
    small: cn(baseStyle, "text-sm font-normal leading-normal font-sentric-alt"),
  };

  const Component = {
    subtitle: "h2",
    small: "small",
    p: "p",
    pMainFont: "p",
    semibold: "p",
  }[as] as React.ElementType;

  return (
    <Component
      ref={ref}
      className={cn(styles[as] || "", className)}
      {...props}
    >
      {children}
    </Component>
  );
});

Text.displayName = "Text";

export default Text;
